import { useNavigate, Link } from "react-router-dom";
import { OfferteForm } from "@/components/offerte/OfferteForm";
import { OfferteStappen } from "@/components/offerte/OfferteStappen";
import { AdSlot } from "@/components/AdSlot";
import { HardHat, ArrowLeft, ClipboardList, Users, Home } from "lucide-react";
import { toast } from "sonner";
import { useSeo } from "@/lib/seo";

export default function OfferteAanvragen() {
  const navigate = useNavigate();
  useSeo({
    title: "Gratis offerte aanvragen voor ramen & deuren | Work4you",
    description: "Vraag vrijblijvend offertes aan bij maximaal 4 geverifieerde bedrijven voor je ramen- en deurenproject. Eenvoudig, snel en tot 31/12/2026 volledig gratis.",
    path: "/offerte-aanvragen",
  });

  const handleComplete = (payload) => {
    try {
      sessionStorage.setItem("offerte_draft", JSON.stringify(payload));
    } catch (e) {
      toast.error("Kon je aanvraag niet bewaren, probeer opnieuw.");
      return;
    }
    toast.success("Aanvraag compleet — maak nu je account aan om te versturen.");
    navigate("/registreren?rol=particulier&intent=offerte");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-slate-950 text-white">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="offerte-home-link">
            <div className="w-9 h-9 bg-orange-500 flex items-center justify-center rounded-sm">
              <HardHat className="w-5 h-5 text-white" />
            </div>
            <span className="font-display text-lg font-extrabold">Work4you</span>
          </Link>
          <div className="flex items-center gap-1 sm:gap-3">
            <Link to="/" data-testid="offerte-nav-home" className="text-sm text-orange-300 hover:text-white flex items-center gap-1 font-semibold">
              <Home className="w-4 h-4" /> <span className="hidden sm:inline">Home</span>
            </Link>
            <Link to="/opdrachten" data-testid="offerte-nav-opdrachten" className="text-sm text-blue-300 hover:text-white flex items-center gap-1 font-semibold">
              <ClipboardList className="w-4 h-4" /> <span className="hidden sm:inline">Opdrachten</span>
            </Link>
            <Link to="/beschikbare_monteurs" data-testid="offerte-nav-monteurs" className="text-sm text-emerald-300 hover:text-white flex items-center gap-1 font-semibold">
              <Users className="w-4 h-4" /> <span className="hidden sm:inline">Professionals</span>
            </Link>
            <Link to="/" className="text-sm text-slate-300 hover:text-white flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Terug
            </Link>
          </div>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 py-8">
        <p className="label-caps text-orange-500 mb-2">Prijsaanvraag</p>
        <h1 className="font-display text-3xl sm:text-4xl font-black text-slate-950 mb-2">
          Vraag vrijblijvend een offerte aan
        </h1>
        <p className="text-slate-600 mb-6 max-w-xl">
          Vul je aanvraag in voor nieuwe ramen en/of deuren, garagepoorten, rolluiken en/of screens en Velux (dakramen).
          Daarna maak je snel een account aan om je aanvraag te versturen.
        </p>

        <OfferteStappen active={1} />

        <AdSlot slot="offerteflow" rol="particulier" className="mb-6 max-w-2xl" />

        <OfferteForm
          user={null}
          onSubmit={handleComplete}
          submitting={false}
          submitLabel="Verder naar mijn gegevens →"
          uploadPath="/uploads/public"
          bedrijvenPath="/bedrijven/public"
        />
      </div>
    </div>
  );
}
